import { LocationChoice } from '../../common/components/SearchHeader/types/LocationChoice';
import { LocationFilters, Maybe } from '../../common/schema/hannibal/types.generated';
import { SuburbType } from '../../corporate/search/LocationBox/SuburbType';

export const locationFiltersFromChoice = (
  choice?: LocationChoice,
  radius?: number,
  teleportLocation?: SuburbType | null,
): Maybe<LocationFilters> => {
  if (teleportLocation && !choice) {
    return {
      aroundGeolocation: {
        latitude: teleportLocation.latitude,
        longitude: teleportLocation.longitude,
      },
    };
  }

  if (!choice) return null;

  if ('state' in choice) {
    return { inState: choice.state };
  }

  if ('metro' in choice) {
    return { inMetro: choice.metro };
  }

  return { inSuburb: [{ ...choice.suburb, radius }] };
};
